import uuid from 'react-uuid';

export const authenticateUser = async (userAuth0) => {
  
  try {
     console.log('User ' + userAuth0.email + ' authenticated successfully!');
    
    // Get the user
    let user = await getUser(userAuth0.email?.toLowerCase());
    if (user) {
      console.log('User ' + user?.email + ' fetched successfully!');
      return user;
    } else {
      if (userAuth0) {
        user = await createUser(userAuth0);
        if (user) {
          console.log('User ' + user?.email + ' created successfully!');
          return user;
        };
      }
        console.log('Could not create new user');
    };
  } catch (error) {
    console.log('Error authenticating user!');
    console.log(error);
    return null;
  };
};

export const getUser = async (email) => {
  try {
    const ENV = process.env.REACT_APP_NODE_ENV;
    const BASE_URL_SSD = 
      ENV === 'production' ? process.env.REACT_APP_BASE_URL_SSD : 
      ENV === 'staging'? process.env.REACT_APP_BASE_URL_SSD_STAGING :
      ENV === 'development' ? process.env.REACT_APP_BASE_URL_SSD_DEVELOPMENT : 
      'http://localhost:8080/api';

    const user = await fetch(`${BASE_URL_SSD}/users`, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
        'email': email
      }
    });
    if (user.ok) return user.json();
    return null;
  } catch (error) {
    console.log('Error finding user!');
    return null;
  };
};

export const createUser = async (user) => {
  try {
    const ENV = process.env.REACT_APP_NODE_ENV;
    const BASE_URL_SSD = ENV === 'production' ? process.env.REACT_APP_BASE_URL_SSD : (ENV === 'staging' || ENV === 'development' ) ? process.env.REACT_APP_BASE_URL_SSD_STAGING : 'http://localhost:8080/api';

    console.log('Creating new user...');
    let newUser = {
      _id: uuid(),
      firstName: user.nickname || "",
      lastName: user.familyName || "",
      email: user.email.toLowerCase(),
      company: user.company || "",
      subscription: "Demo",
      createdOn: new Date(),
      updatedOn: new Date(),
      lastSignin: new Date(),
      projects: [],
      darkMode: false,
      fbaAccess: false,
      rtfoAccess: false
    };

    const response = await fetch(`${BASE_URL_SSD}/users`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY
      },
      body: JSON.stringify(newUser)
    });

    if (response.ok) {
      return newUser;
    } else {
      console.log('Could not create user!');
      return null;
    };
  } catch (error) {
    console.log('Error creating user!');
    return null;
  };
};

export const acceptTermsConditionsApi = async (email) => {
  try {
    const ENV = process.env.REACT_APP_NODE_ENV;
    const BASE_URL_SSD = ENV === 'production' ? process.env.REACT_APP_BASE_URL_SSD : (ENV === 'staging' || ENV === 'development' ) ? process.env.REACT_APP_BASE_URL_SSD_STAGING : 'http://localhost:8080/api';

    const user = await fetch(`${BASE_URL_SSD}/users/terms`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify({ 'email': email })
    });
    if (user.ok) return user.json();
    return null;
  } catch (error) {
    return null;
  };
};

export const toggleDarkModeApi = async (email, darkMode) => {
  try {
    const ENV = process.env.REACT_APP_NODE_ENV;
    const BASE_URL_SSD = ENV === 'production' ? process.env.REACT_APP_BASE_URL_SSD : (ENV === 'staging' || ENV === 'development' ) ? process.env.REACT_APP_BASE_URL_SSD_STAGING : 'http://localhost:8080/api';

    console.log('Updating dark mode settings');
    const user = await fetch(`${BASE_URL_SSD}/users/darkmode`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify({ 'email': email, 'darkMode': darkMode })
    });
    if (user.ok) return true;
    return null;
  } catch (error) {
    return null;
  };
};